import { FormlyFieldConfig } from '@ngx-formly/core';
import { DetailsFormOptions } from './details-form-options.interface';
import { getGeneralFields } from './details-form-general';
import { getClientFields } from './details-form-client';
import { getClientEmergencyContactsFields } from './details-form-client-emergency-contacts';
import { getCoApplicantFields } from './details-form-coapplicant';
import { getCoApplicantEmergencyContactsFields } from './details-form-coapplicant-emergency-contacts';

/**
 * Main configuration builder
 * Combines all sections into expansion panels
 */
export function buildDetailsFormConfig(options: DetailsFormOptions): FormlyFieldConfig[] {
  return [
    {
      expressions: {
         className: "model._selectedTab !== 'details' && model._selectedTab !== 'details-general' ? 'hidden-section' : ''",
      },
      fieldGroup: [
        {
          type: 'section-header',
          props: {
            id: 'details-general',
            label: 'General',
            description: "Application information",
          },
        },
        {
          fieldGroup: getGeneralFields(options),
        },
      ]
    },
    {
      expressions: {
        className: "model._selectedTab !== 'details-client' ? 'hidden-section' : ''",
      },
      fieldGroup: [
        {
          type: 'section-header',
          props: {
            id: 'details-client',
            label: 'Client',
            description: "Pre-qualifying, referral, personal, banking and employment details",
          },
        },
        {
          fieldGroup: getClientFields(options),
        },
      ],
    },
    {
      expressions: {
        className: "model._selectedTab !== 'details-client-emergency-contacts' ? 'hidden-section' : ''",
      },
      fieldGroup: [
        {
          type: 'section-header',
          props: {
            id: 'details-client-emergency-contacts',
            label: 'Client Emergency Contacts',
            description: "People to contact in an emergency",
          },
        },
        {
          fieldGroup: getClientEmergencyContactsFields(options),
        },
      ]
    },
    {
      expressions: {
        hide: (field: FormlyFieldConfig) => field.model?.Co_Appl_Required !== 'Yes',
        className: "model._selectedTab !== 'details-coapplicant' ? 'hidden-section' : ''",
      },
      fieldGroup: [
        {
          type: 'section-header',
          props: {
            id: 'details-coapplicant',
            label: 'Co-applicant',
            description: "Pre-qualifying, personal, banking and employment details",
          },
        },
        {
          fieldGroup: getCoApplicantFields(options),
        },
      ]
    },
    {
      expressions: {
        hide: (field: FormlyFieldConfig) => field.model?.Co_Appl_Required !== 'Yes',
        className: "model._selectedTab !== 'details-coapplicant-emergency-contacts' ? 'hidden-section' : ''",
      },
      fieldGroup: [
        {
          type: 'section-header',
          props: {
            id: 'details-coapplicant-emergency-contacts',
            label: 'Co-Applicant Emergency Contacts',
            description: "People to contact in an emergency",
          },
        },
        {
          fieldGroup: getCoApplicantEmergencyContactsFields(options),
        },
      ],
    },
  ];
}